<template>
  <LayoutContainer :id="_id" class="mt-12">
    <h1 class="mb-5 text-center text-lg font-bold uppercase tracking-wide">
      {{ title }}
    </h1>

    <PostContent class="mb-12" :content="content" />
  </LayoutContainer>
</template>

<script setup lang="ts">
import type { Pages } from "~/@types/pages"

const props = defineProps<{
  post: Pages
}>()

const { post } = toRefs(props)

const { _id, title, content } = usePage(post.value)
</script>
